// import Swiper from "swiper"
import { find } from "../utils/dom"

export default function () {
	const Home = find("[js-page='programs']")
	if (!Home) return
	console.log('Page Programs');
	
const cards = document.querySelectorAll('[data-programs-mobile]')

	cards.forEach(card =>{
			card.addEventListener('click',(e)=>{
				const svg = card.querySelector('svg')
				const paragraph = card.querySelector('.paragraph-content')
				svg.classList.toggle('rotate-180')
				paragraph.classList.toggle('hidden')
			})
	})

}